import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import React from 'react'

/** SP向けの短い日時（例: 8/20 (水) 07:37） */
export function formatCompactDateTime(value, lang) {
  if (!value) return '-'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '-'
  return lang === 'en'
    ? format(d, 'M/d (EEE) HH:mm')
    : format(d, 'M/d (E) HH:mm', { locale: ja })
}

/** レポート状態のコンパクトバッジ */
export function getCompactStatusBadge(status, lang) {
  const map = lang === 'en'
    ? { 0: 'Unconfirmed', 1: 'In Prep', 2: 'Done' }
    : { 0: '未確認', 1: '準備中', 2: '完了' }
  const colors = {
    0: { backgroundColor: '#f2dbcb', color: '#7a4a2b' },
    1: { backgroundColor: '#cce6f2', color: '#1f5f7a' },
    2: { backgroundColor: '#ccf2d6', color: '#1f6b3a' },
  }
  if (map[status] == null) return null
  return (
    <span className="mobile-compact-badge is-status" style={colors[status]}>
      {map[status]}
    </span>
  )
}
